import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';
import { JsonInput } from 'shared/react-admin/Inputs/JsonInputIntrospected/JsonInput';

export const JsonInputStyled = styled(JsonInput)(({ theme }) => ({
  '& .jer-editor-container': {
    background: `${theme.palette.background.paper} !important`,
    border: `1px solid ${theme.palette.action.disabled}`,
    maxWidth: '707px !important',
    height: '152px',
    overflow: 'auto',
  },
}));

export const BoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '20px',
});

export const InfoIconStyled = styled(InfoOutlined)(({ theme }) => ({
  height: '24px',
  width: '24px',
  color: theme.palette.secondary.main,
}));
